export default __webpack_public_path__ + "static/media/icon.0dc33a3e.svg";